import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import * as css from './index.module.css';
import { jsx as ___EmotionJSX } from "@emotion/react";
export function PriceWrap(props) {
  return ___EmotionJSX("div", _extends({
    id: props.name,
    className: css.priceWrap + " " + props.className,
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children);
}